// File: src/components/MatchFlow/ExitEventPortalBottomSheet.jsx

import React, { useEffect } from 'react';
import { FaDoorOpen } from 'react-icons/fa';

function isPWA() {
  return (
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true
  );
}

export default function ExitEventPortalBottomSheet({ visible, onCancel, onConfirm }) {

  useEffect(() => {
    const themeMetaTag = document.querySelector('meta[name="theme-color"]');
  
    if (visible) {
      document.body.classList.add('overlay-active');
      document.documentElement.classList.add('overlay-active');
      document.getElementById('root').classList.add('overlay-active');
      if (themeMetaTag) themeMetaTag.content = '#999998';
    } else {
      document.body.classList.remove('overlay-active');
      document.documentElement.classList.remove('overlay-active');
      document.getElementById('root').classList.remove('overlay-active');
      if (themeMetaTag) themeMetaTag.content = '#ffffff';
    }
  
    return () => {
      document.body.classList.remove('overlay-active');
      document.documentElement.classList.remove('overlay-active');
      document.getElementById('root').classList.remove('overlay-active');
      if (themeMetaTag) themeMetaTag.content = '#ffffff';
    };
  }, [visible]);  

  if (!visible) return null;


  return (
    <>
      <div style={styles.backdrop}>
        <div style={styles.sheetContainer}>
          <div style={styles.content}>
            <div style={styles.iconWrapper}>
              <FaDoorOpen style={styles.icon} />
            </div>
            <div style={styles.textWrapper}>
              <p style={styles.title}>Exit Event Portal?</p>
              <p style={styles.subheading}>
                If you exit, you’ll be removed from the event rooms and will need to go 
                through the introduction steps again to rejoin.
              </p>
            </div>
          </div>
          <div style={styles.buttonRow}>
            <button style={styles.cancelButton} onClick={onCancel}>
              Cancel
            </button>
            <button style={styles.confirmButton} onClick={onConfirm}>
              Confirm
            </button>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </>
  );
}

const styles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  sheetContainer: {
    width: '100%',
    maxWidth: 480,
    margin: '0 8px 8px',
    marginBottom: isPWA() ? 40 : 8, // Adjusted margin-bottom for PWA
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: '0 -4px 12px rgba(0,0,0,0.15)',
    minHeight: 400,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '16px',
    boxSizing: 'border-box',
    animation: 'slideUp 0.3s ease-out',
  },
  content: {
    textAlign: 'center',
  },
  iconWrapper: {
    marginBottom: 12,
  },
  icon: {
    fontSize: '3rem',
    color: '#C22D2D',
    paddingTop: '20%',
  },
  textWrapper: {
    maxWidth: '90%',
    margin: '0 auto',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#000',
    margin: '0 0 8px',
  },
  subheading: {
    fontSize: '0.85rem',
    color: '#555',
    margin: 0,
    lineHeight: 1.4,
  },
  buttonRow: {
    display: 'flex',
    gap: '12px',
  },
  cancelButton: {
    flex: 1,
    backgroundColor: '#f0f0f0',
    color: '#333',
    border: 'none',
    borderRadius: 8,
    padding: '6px 12px',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
  },
  confirmButton: {
    flex: 1,
    border: 'none',
    backgroundColor: '#C22D2D',
    color: '#fff',
    borderRadius: 8,
    fontSize: 15,
    fontWeight: 600,
    padding: '12px 0',
    cursor: 'pointer',
    fontFamily: "'Open Sans', sans-serif",
    maxWidth: 178,
  },
};
